// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"123":"0ef63f8e","728":"faad4f51","815":"b619991d","927":"ea0dd7df"}[chunkId] + ".js";
};